import { memo, useMemo, type FC } from 'react';

import { TableCell } from '../TableCell/index.tsx';
import { TableCellContentType } from '../TableCell/types.ts';
import { TableRow } from '../TableRow/index.tsx';
import { TableLoaderBar } from './styled.ts';
import type { TableLoaderProps } from './types.ts';

export const TableLoader: FC<TableLoaderProps> = memo(function TableLoader({ columnsLength, rows = 3, dataTestId }) {
  const rowsArray = useMemo(() => [...Array.from({ length: rows }, (_, i) => i)], [rows]);
  const columnsArray = useMemo(() => [...Array.from({ length: columnsLength }, (_, i) => i)], [columnsLength]);

  return (
    <>
      {rowsArray.map((i) => (
        <TableRow key={i} dataTestId={dataTestId}>
          {columnsArray.map((j) => (
            <TableCell contentType={TableCellContentType.LOADING} key={j}>
              <TableLoaderBar />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
});
